import React, { Component } from 'react';
import "firebase/database";
import { Footer } from './footer';
import $ from 'jquery';

export class Layout extends Component {
    displayName = Layout.name;

    constructor(props) {
        super(props);
        this.state = {
          aceptaCookies: localStorage.getItem('aceptaCookies') == 'true'
        };
    }

    componentDidMount() {
        this.setState(
            {
                aceptaCookies: this.getCookie()
            }
        );
    }

    render() {
        return (
            <div className='layout'>
                {
                    this.props.children
                }
                <Footer/>
                {
                    !this.state.aceptaCookies && (
                        <div className='cookie-panel show'>
                            <p>
                                Esta web utiliza cookies analíticas para recabar estadísticas sobre la actividad del usuario en la web y la actividad general de la misma. La información recopilada es anónima y permite optimizar la navegación por nuestra página web así como garantizar el mejor servicio al usuario. 
                                <a href='/cookies'>Saber más</a>
                            </p>
                            <button type="button" onClick={() => {
                                this.setCookie();
                            }}>Aceptar</button>
                        </div>
                    )
                }
            </div>
        );
    }

    setCookie() {
        localStorage.aceptaCookies = 'true';
        
        this.setState({
            aceptaCookies: true
        });
    }

    getCookie() {
        return localStorage.getItem('aceptaCookies') == 'true';
    }
}